global.jQuery = require("jquery");
var $ = global.jQuery,
    magnificPopup = require("magnific-popup"),
    waypoints = require("waypoints/lib/jquery.waypoints"),
    imagesLoaded = require("imagesloaded"),
    ModalVideo = require('modal-video'),
    slick = require('slick-carousel'),
    Cookies = require("js-cookie"),
    ktTabs = require("../js/libs/kt-tabs-min"),
    ktSlick = require("../js/libs/kt-slick-init"),
    packery = require('isotope-packery'),
    Isotope = require('isotope-layout');

$(function () {

    let body = $('body');

    function siteLoaded(callback) {
        body.imagesLoaded({background: '.bkg'}, function () {
            if (!body.hasClass('bloaded')) {
                // loader.velocity("fadeOut", {
                //    duration: 500, complete: function () {
                        body.addClass('bloaded');
                        callback();
                //    }
                // });
            } else {
                callback();
            }
        });
    }


    function cookieLaw() {
        var cookieMessage = $('#cookie-message'),
            seenCookie = Cookies.get('seenCookie');
        if (seenCookie !== 'yes') {
            cookieMessage.show();
            Cookies.set('seenCookie', 'yes', {expires: 365});
        }
    }



    function scrollTo() {
        $('.scroll-to-link').click(function (e) {
            e.preventDefault();
            var id = $(this).attr('href');
            $('html, body').animate({scrollTop: $(id).offset().top - 150}, 'slow');
        });
    }


    $(document).scroll(function () {
        var $nav = $("#sticky-nav");
        $nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height());
    });

    function socialShare() {
        var twitterShare = document.querySelector('[data-js="twitter-share"]');

        if (twitterShare != null) {
            twitterShare.onclick = function (e) {
                e.preventDefault();
                var twitterWindow = window.open('https://twitter.com/share?url=' + document.URL, 'twitter-popup', 'height=350,width=600');
                if (twitterWindow.focus) {
                    twitterWindow.focus();
                }
                return false;
            }
        }

        var facebookShare = document.querySelector('[data-js="facebook-share"]');

        if (facebookShare) {
            facebookShare.onclick = function (e) {
                e.preventDefault();
                var facebookWindow = window.open('https://www.facebook.com/sharer/sharer.php?u=' + document.URL, 'facebook-popup', 'height=350,width=600');
                if (facebookWindow.focus) {
                    facebookWindow.focus();
                }
                return false;
            }
        }
        var linkedInShare = document.querySelector('[data-js="linkedin-share"]');
        if (linkedInShare) {
            linkedInShare.onclick = function (e) {
                window.open('http://www.linkedin.com/shareArticle?mini=true&url=' + encodeURIComponent(document.URL), '', 'left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0');
            }
        }
    }







    function WaypointSticky() {
        var subnavElements = document.getElementById('subnav-container');
        if ($(subnavElements).length) {
            var waypoint = new Waypoint({
                element: subnavElements,
                handler: function (direction) {
                    $(subnavElements).toggleClass('sticky');
                },
                offset: '0'
            })
        }
    }

    function scrollDown() {
        $('#scroll-start').click(function () {
            $('html, body').animate({scrollTop: $('#start').offset().top - 150}, 'slow');
        })
    }


    function grid() {
        var myGrid = document.getElementById('grid');
        if (typeof(myGrid) != 'undefined' && myGrid != null) {
            var myGrid = new Isotope('#grid', {
                layoutMode: 'packery',
                itemSelector: '.item',
                percentPosition: true
            });

            if($('#filter').length > 0) {
                $('#filter').change(function(){
                    let filter = $(this).find("option:selected").attr('value');
                    myGrid.arrange({ filter: filter });
                    window.location.hash=filter.replace(".", "");
                });
            }


            var hash = location.hash;
            if(hash) {
                var preFilter = hash.replace("#", ".");
                myGrid.arrange({ filter: preFilter });
            }


        }
    }


    function menuSystem() {

        $('.trigger-child').on('click', function (e) {
            e.preventDefault();

            var that = $(this),
                target = that.attr('href');

            $(target).toggleClass('open');
        });

    }


    function toggleMenu() {
        $('#menu-toggle').on('click', function (e) {
            e.preventDefault();

            $('#menu').toggleClass('open');

        })
    }





    siteLoaded(function () {
        cookieLaw();
        socialShare();
        scrollTo();
        scrollDown();
        WaypointSticky();
        grid();
        toggleMenu();
        menuSystem();
    });

});



// WEBPACK FOOTER //
// ./resources/js/script.js